import { ArrowLeftOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'src/components/Link/Link';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

type BackButtonProps = {
    to?: string;
    text?: string;
};

export const BackButton = observer(({ to, text }: BackButtonProps) => {
    const { t } = useTranslation();

    return (
        <StyledLink
            button
            buttonType="text"
            icon={<ArrowLeftOutlined />}
            to={to}
        >
            {text || t('App.Components.BackButton.Back')}
        </StyledLink>
    );
});

const StyledLink = styled(Link)`
    padding-left: 0;
    color: ${CssColors.gray};

    a {
        color: ${CssColors.gray};
    }

    &:hover {
        background: none;
        color: ${CssColors.black};

        a {
            color: ${CssColors.black};
        }
    }
`;
